<template>
  <div class="app-breadcrumbs">
    <template v-if="isOpen">
      <div class="scrollable-breadcrumbs-container">
        <!-- <div class="scrollable-breadcrumbs"> -->
        <template v-for="(route, idx) in breadcrumbs">
          <div
            v-if="idx != 0"
            :key="idx"
            class="icon icon-back mx-5 separator"
          ></div>
          <router-link :key="idx" :to="{ name: route.name }">
            {{ route | get('title', 'Error') }}
          </router-link>
        </template>
        <!-- </div> -->
      </div>
      <span class="divider-line ml-15"></span>
    </template>
    <button v-if="nCrumbs > 1" class="button is-text" @click="isOpen = !isOpen">
      <span
        class="icon"
        :class="{ 'icon-close': isOpen, 'icon-all-back': !isOpen }"
      >
      </span>
    </button>
    <template v-if="!isOpen && nCrumbs > 0">
      <span v-if="nCrumbs > 1" class="divider-line mx-15"></span>
      <router-link class="button is-text" :to="{ name: lastRoute.name }">
        <span class="icon icon-back is-narrow"></span>
        <span>{{ lastRoute | get('title', 'Back') }}</span>
      </router-link>
    </template>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'AppBreadcrumbs',
  props: {
    backTitle: {
      type: String,
      default: ''
    },
    backRouteName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpen: false,
      breadcrumbs: []
    };
  },
  computed: {
    nCrumbs() {
      //console.log('nCrumbs', this.breadcrumbs.length);
      return this.breadcrumbs.length;
    },
    lastRoute() {
      if (this.backTitle != '' && this.backRouteName != '') {
        return {
          name: this.backRouteName,
          title: this.backTitle
        };
      } else {
        const lastRouteName = _.nth(this.$route.meta.breadcrumbs, -1);
        const lastRoute = this.$router.resolve({ name: lastRouteName });
        return {
          name: lastRoute.route.name,
          title: lastRoute.route.meta.title
        };
      }
    }
  },
  mounted() {
    this.breadcrumbs = this.$route.meta.breadcrumbs
      .map(el => this.$router.resolve({ name: el }))
      .map(r => ({ name: r.route.name, title: r.route.meta.title }));
  }
};
</script>

<style lang="scss">
.app-breadcrumbs {
  display: flex;
  align-items: center;
  width: 100%;
  .divider-line {
    width: 1px;
    height: 3rem;
    display: inline-block;
  }
  .separator {
    opacity: 0.3;
  }
  a {
    color: $text;
    white-space: nowrap;
    display: inline-block;
    &:hover {
      opacity: 0.6;
    }
  }
  .scrollable-breadcrumbs-container {
    overflow-x: auto;
    display: flex;
    align-items: center;
    // .scrollable-breadcrumbs {
    // }
  }
}
</style>
